/**
 * Persists a key/value to local storage
 * @param {string} key The key to retrieve
 * @param {string|object|array} value The value to save
 */
export const set = (key, value) => {
  // Browser check!
  if (typeof Storage !== 'undefined') {
    let safeValue = value
    if (typeof value !== 'string') {
      safeValue = JSON.stringify(value)
    }
    localStorage.setItem(key, safeValue)
  }
}

/**
 * Get local storage value
 * @param {string} key The key to retrieve
 * @param {boolean} parseJSON Would you like to JSON.parse() the result
 */
export const get = (key, parseJSON = false) => {
  if (typeof Storage !== 'undefined') {
    const savedValue = localStorage.getItem(key)
    return parseJSON ? JSON.parse(savedValue) : savedValue
  }
}

/**
 * Deletes a key from localStorage
 * @param {string} key The key to delete
 */
export const remove = key => {
  if (typeof Storage !== 'undefined') {
    localStorage.removeItem(key)
  }
}
